import common from './common';

export default {
  ...common.button,
  bg: '#475467',
  borderRadius: 'full',
  minWidth: 'auto',
  color: `white`,
  '::after': {
    ...common.button['::after'],
    bg: `alpha`,
    borderColor: `alpha`,
  },
  ':hover': {
    '::after': {
      transform: `scale(1.08)`,
      transitionTimingFunction: `cubic-bezier(0.47, 2.02, 0.31, 0.1)`,
    },
    '::before': {
      opacity: 1,
      transform: `scale(1.08) perspective(15px)`,
    },
  },
  ':active': {
    '::after': {
      transform: `scale(1.02)`,
      transitionTimingFunction: `cubic-bezier(0.47, 2.02, 0.31, 0.1)`,
    },
  },
};
